import { useQuery } from "@tanstack/react-query";
import { CardErrorsResponse } from "tng-address-collection-shared/types/apiTypes.ts";
import { useAuthentication } from "../auth/useAuthentication.ts";
import { queryKeys } from "./queryKeys.ts";

export const useCardErrors = () => {
  const { getToken, isAuthenticated } = useAuthentication();

  return useQuery({
    queryKey: queryKeys.cardErrors(),
    queryFn: async ({ signal }): Promise<CardErrorsResponse> => {
      const token = await getToken();
      const response = await fetch("/api/cards/errors", {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        signal,
      });

      if (!response.ok) {
        throw new Error("Server returned status outside the 200 range.");
      }
      return CardErrorsResponse.parse(await response.json());
    },
    enabled: isAuthenticated,
  });
};
